import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import API from '../../../../api/api'
import { PAYMENT_STAGES } from '../../ParkingPaymentPage'

const ParkingPaymentElement = ({ setStage, totalPrice, serviceFee, ticketNumber, tip }) => {
  const { t } = useTranslation(['parking'])
  const stripe = useStripe()
  const elements = useElements()

  const [paymentLoading, setPaymentLoading] = useState(false)

  const handlePay = async (event) => {
    event.preventDefault()
    if (!stripe) {
      return
    }

    setPaymentLoading(true)

    const { error: submitError } = await elements.submit()
    if (submitError) {
      setPaymentLoading(false)
      return
    }

    try {
      const response = await API.payForParking(serviceFee, ticketNumber, (tip || 0) * 100)
      const clientSecret = response.data.clientSecret
      await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}/parking/${ticketNumber}/payment-success`,
        },
        redirect: 'if_required',
      })
      setStage(PAYMENT_STAGES.SUCCESS)
    } catch {
      setStage(PAYMENT_STAGES.ERROR)
    }
  }

  return (
    <form onSubmit={handlePay} className="payment-form">
      <PaymentElement />
      <button
        disabled={paymentLoading || !stripe}
        className="button is-black full-width"
        style={{ marginTop: '8px' }}
      >
        {t('parking:payAmount', { totalPrice })}
      </button>
    </form>
  )
}

ParkingPaymentElement.propTypes = {
  totalPrice: PropTypes.number,
  tip: PropTypes.number,
  serviceFee: PropTypes.number,
  ticketNumber: PropTypes.string,
  setStage: PropTypes.func,
}

export default ParkingPaymentElement
